<template>
  <v-card flat
    tile
    :max-width="fullWidth ? '' : '600px'">
    <v-card-text class="pa-2 flavor-text">
      <span class="text-cc-overline">// PROCESS INTERRUPT: AUTHORIZATION REQUIRED //</span>
      <br />
      <span v-if="!noCc"
        style="opacity: 0.4">>>COMP/CON//&nbsp;</span>
      <span v-html-safe="content" />
      <v-divider class="my-2" />
      <v-card-actions class="my-n3">
        <cc-button v-if="cancellable"
          size="small"
          variant="text"
          color="error"
          @click="$emit('cancel')">
          CANCEL
        </cc-button>
        <v-spacer />
        <cc-button size="small"
          color="primary"
          @click="$emit('confirm')">CONFIRM</cc-button>
      </v-card-actions>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
export default {
  name: 'CcConfirmation',
  props: {
    content: {
      type: String,
      required: true,
    },
    noCc: { type: Boolean },
    cancellable: { type: Boolean },
    fullWidth: { type: Boolean },
  },
  emits: ['confirm', 'cancel'],
};
</script>
